function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 3L5 0V3H115L88 24L115 45H0V3Z",
  fill: "url(#paint0_linearP)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linearP",
  x1: -0.00000335135,
  y1: 43.8,
  x2: 104.565,
  y2: -0.719851,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0677083,
  stopColor: "#BBB8C9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.190333,
  stopColor: "#9490A4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.292568,
  stopColor: "#797686"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.461172,
  stopColor: "#767383"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.643466,
  stopColor: "#827E8F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.820833,
  stopColor: "#928FA0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C8C4D6"
})));

function SvgTagPlatinum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 45,
    viewBox: "0 0 115 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagPlatinum);
export default __webpack_public_path__ + "static/media/tagPlatinum.60eca130.svg";
export { ForwardRef as ReactComponent };